module.exports = __webpack_public_path__ + "img/corporate-social-responsibility.cd805845.png";